import { render, staticRenderFns } from "./LeaderboardMedium.vue?vue&type=template&id=69cd518e&scoped=true"
import script from "./LeaderboardMedium.vue?vue&type=script&lang=js"
export * from "./LeaderboardMedium.vue?vue&type=script&lang=js"
import style0 from "./LeaderboardMedium.vue?vue&type=style&index=0&id=69cd518e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cd518e",
  null
  
)

export default component.exports